@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.PercentBar {
  @extend %font-family-primary;

  font-size: xx-small;
  border: 1px solid $color-input-border;
  border-radius: 4px;
  display: flex;

  > span {
    padding: 1px 0;
  }

  .Fill {
    text-align: right;
    color: $color-white;
    background: $color-coverage-percentbar-fill;
    box-sizing: border-box;
  }

  .NoFill {
    color: $color-input-border;
  }
}
